module.exports = __webpack_public_path__ + "media/react/assets/images/not-found-e8853d43acc19cbbc75ab50bcf159c31.png";